import Vue from 'vue'
import VueRouter from 'vue-router'
import { routerBeforeEach } from './beforeEach'
import { routes } from './routes'
// import { isAllowed } from '../utils/authentication'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(routerBeforeEach)

export default router
